import React, { useEffect, useMemo, useState } from "react";
import { Column } from "@ant-design/plots";
import styled from "@emotion/styled";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { Button } from "antd";

const StyledTitle = styled.div`
  font-size: 0.9rem;
  font-weight: bold;
  color: #141414;
  margin-bottom: 10px;
`;

const StyledChartContainer = styled.div`
  border: solid 1px #9b9b9b;

  border-radius: 3px;
  padding: 10px;
  margin-bottom: 25px;
  .name-title {
    padding: 3px 10px;
    font-size: 1rem;
    padding-bottom: 15px;
  }
  img,
  svg {
    vertical-align: initial !important;
  }
`;

const ButtonOutlined = styled(Button)`
  padding: -10px 10px !important;
  border: 1px solid
    "#2D53DA;
  border-radius: 5px;
  background: transparent;
  font-weight: normal;
  color: "
    #2d53da;
  white-space: nowrap;

  &:hover {
    border: 1px solid "#2D53DA;
    background: #f1f3f4;
    color: " #2d53da;
  }
  &:focus {
    border: 1px solid "#2D53DA;
    background: #f1f3f4;
    color: " #2d53da;
  }
  @media (max-width: 900px) {
    margin: 10px 0px;
  }
`;

function EmployeesPerRole({ report }) {
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 20;

  const maxPage = Math.floor(report?.length / itemsPerPage);

  const handlePrev = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 0));
  };

  const handleNext = () => {
    console.log("handlenext");
    setCurrentPage((prev) => Math.min(prev + 1, maxPage));
  };

  const paginatedData = report.slice(
    currentPage * itemsPerPage,
    (currentPage + 1) * itemsPerPage
  );
  const config = {
    padding: "auto",
    data: paginatedData,
    height: 300,
    xField: "rolename",
    yField: "users",
    seriesField: "rolename",
    label: {
      position: "top",
      // content:''
    },
    columnStyle: {
      cursor: "pointer",
    },
    legend: false,
    xAxis: {
      label: {
        formatter: (value) => value.slice(0, 3).toUpperCase(),
        offset: 10,
        autoHide: false,
        autoRotate: true,
      },
    },
    yAxis: {
      max: 70,
      grid: {
        line: {
          style: {
            opacity: 0,
          },
        },
      },
    },
    theme: {
      colors20: [
        "#3C88C0",
        "#4BA7B3",
        "#5AC39B",
        "#6ADD7F",
        "#A8DD6A",
        "#DDDD6A",
      ],
    },
  };

  return (
    <>
      <StyledTitle>Number Of Employees Per Role</StyledTitle>
      <StyledChartContainer>
        <div className="w-100 text-end">
          <ButtonOutlined
            className="mx-2"
            onClick={handlePrev}
            disabled={currentPage === 0}
          >
            <LeftOutlined />
          </ButtonOutlined>
          <ButtonOutlined
            className="mx-2"
            onClick={handleNext}
            disabled={currentPage === maxPage - 1}
          >
            <RightOutlined />
          </ButtonOutlined>
        </div>

        <Column {...config} />
      </StyledChartContainer>
    </>
  );
}

export default EmployeesPerRole;
